import { render, staticRenderFns } from "./VerticalFloatingIcons.vue?vue&type=template&id=70719aea&scoped=true"
import script from "./VerticalFloatingIcons.vue?vue&type=script&lang=js"
export * from "./VerticalFloatingIcons.vue?vue&type=script&lang=js"
import style0 from "./VerticalFloatingIcons.vue?vue&type=style&index=0&id=70719aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70719aea",
  null
  
)

export default component.exports